export enum Resources {
  PATIENTS = 'patients',
  HOSPITALS = 'hospitals',
  DRUGS = 'drugs-xls',
  MANAGERS = 'hospital-managers',
}
